// extracted by mini-css-extract-plugin
export default {"summaryWrapper":"ganttSummary_summaryWrapper__hitY2","column":"ganttSummary_column__CFR0B","content":"ganttSummary_content__7W5xc"};